import { useQuery } from 'react-query';
import { getPdf } from '../../../apiCallFunctions/pdfBuilder';
import { StateDTO } from '../../../app/models/GeneralDTO';
import { useDispatch, useSelector } from 'react-redux';
import { updateCheckValue } from '../../../actions/report';

export const useGetPdf = (widgetsRef) => {
  const { generatePdfStarter, widgetsInDropZone } = useSelector(
    (state: StateDTO) => state.report
  );
  const { currentProject, currentIndicator } = useSelector(
    (state: StateDTO) => state.projects
  );
  const dispatch = useDispatch();

  const { data, isLoading, isError, isSuccess, isFetching, remove } = useQuery(
    ['getPdf'],
    () => getPdf(currentProject.id, currentIndicator.id, widgetsInDropZone),
    {
      enabled: generatePdfStarter,
      retry: false,
      refetchOnWindowFocus: false,
      onSuccess: (data) => {
        widgetsRef.current = widgetsInDropZone;
        dispatch(updateCheckValue('generatePdfStarter', false));
        dispatch(updateCheckValue('pdfDocumentId', data?.data?.id));
      },
    }
  );

  return {
    data: data?.data,
    isLoading,
    isError,
    isSuccess,
    isFetching,
    remove,
  };
};
